/* eslint-disable no-useless-escape */
/* eslint-disable @typescript-eslint/no-explicit-any */
import _ from 'lodash'
import moment from 'moment'
import { toast } from 'react-toastify'
import WhiteCheckIcon from '../assets/images/white-check.svg'
import GrayCheckCheckIcon from '../assets/images/gray-check.svg'

export const getToken = (key: string) => localStorage.getItem(key)

export const validateToken = () => {
  const token = getToken('login-auth-token')
  const isLoggedIn = getToken('isLoggedIn')
  if (token && isLoggedIn) {
    return true
  }
  return false
}

export const setToken = (key: string, token: any) =>
  Promise.resolve().then(() => {
    localStorage.setItem(key, token)
  })

export const setRole = (value: string) => {
  localStorage.setItem('role', value)
}

export const letterCounter = (text: any) => {
  let count = 0
  const split = text.split('')
  for (let i = 0; i < split.length; i++) {
    if (split[i] != '') {
      count++
    }
  }
  return count
}

export function convert12hTo24h(timeHour, addMinute = 0) {
  const time = timeHour
  let hours = Number(time.match(/^(\d+)/)[1])
  let minutes = Number(time.match(/:(\d+)/)[1])
  const AMPM = time.match(/\s(.*)$/)[1]
  if (AMPM == 'PM' && hours < 12) hours = hours + 12
  if (AMPM == 'AM' && hours == 12) hours = hours - 12
  minutes = minutes + addMinute
  let sHours = hours.toString()
  let sMinutes = minutes.toString()
  if (hours < 10) sHours = '0' + sHours
  if (minutes < 10) sMinutes = '0' + sMinutes
  return sHours + ':' + sMinutes
}

export function convertMinToHMS(date: any) {
  return new Date(date * 60 * 1000).toISOString().substr(11, 8)
}

//convert hh:mm:ss to milisec substr(11, 8)
export function convertMinToMilisec(timePeriod) {
  const parts = timePeriod.split(/:/)
  const timePeriodMillis =
    parseInt(parts[0], 10) * 60 * 60 * 1000 +
    parseInt(parts[1], 10) * 60 * 1000 +
    parseInt(parts[2], 10) * 1000
  return timePeriodMillis
}

export const getDifficultyLabel = (level: string) => {
  switch (level) {
    case 'M':
      return 'Medium'
    case 'E':
      return 'Easy'
    case 'H':
      return 'Hard'
    default:
      return ''
  }
}

export const formatDate = (date: string) => {
  return new Date(date?.split('T')[0])
    .toString()
    .replace(/\S+\s(\S+)\s(\d+)\s(\d+)\s.*/, '$2-$1-$3')
}

export const getBatchType = (batchType: string) => {
  const batchTypeDict = {
    G: 'Assessment',
    NW: 'Nationwide',
    H: 'Hiring',
  }
  return batchTypeDict[batchType]
}

export const getQuestionType = (questionType) => {
  const questionTypeDict = {
    MCQ: 'MCQ',
    TF: 'True/False',
    ES: 'Essay',
    MTF: 'Match The Following',
    FIB: 'Fill In The Blanks',
  }
  return questionTypeDict[questionType]
}

export const getQuestionDifficultyType = (complexityType) => {
  const complexityTypeDict = {
    E: 'Easy',
    M: 'Medium',
    H: 'Hard',
  }
  return complexityTypeDict[complexityType]
}

export const getLast12months = () => {
  const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ]
  const monthsArray: any[] = []
  const date = new Date()
  date.setDate(1)
  for (let i = 0; i < 12; i++) {
    monthsArray.push({
      id: monthNames[date.getMonth()] + ' ' + date.getFullYear(),
      name: monthNames[date.getMonth()] + ' ' + date.getFullYear(),
    })
    date.setMonth(date.getMonth() - 1)
  }
  return monthsArray
}

export const formatCheckBoxValues = (values) => {
  if (values && values?.length > 0) {
    values.map((elem) => {
      if (
        (typeof elem?.is_correct != 'boolean' && elem?.is_correct == 'on') ||
        elem.is_correct == true
      ) {
        elem['is_correct'] = true
      } else {
        elem['is_correct'] = false
      }
    })
  }
  return values
}

export const showErrorToastMessage = (message) => {
  toast.error(message)
  toast.clearWaitingQueue()
}

export const successToast = (msg: string) => {
  toast.success(msg)
}

export const debounceSearch = _.debounce((dispatchAction: () => any) => {
  dispatchAction && dispatchAction()
}, 500)

export const QUESTION_TYPES = {
  ESSAY: 'ES',
  MCQ: 'MCQ',
  TRUE_FALSE: 'TF',
}

export const secondsToHms = (sec: number) => {
  sec = Number(sec)
  if (isNaN(sec)) return '00:00:00'
  const h = Math.floor(sec / 3600)
  const m = Math.floor((sec % 3600) / 60)
  const s = Math.floor((sec % 3600) % 60)
  let hDisplay: string
  if (sec > 86400) {
    hDisplay = '1 Day, ' + ' '
  } else {
    hDisplay = h > 0 ? h + ' h, ' : ''
  }
  const mDisplay = m > 0 ? m + (m === 1 ? ' min, ' : ' mins, ') : ''
  const sDisplay = s > 0 ? s + (s === 1 ? ' sec' : ' secs') : ''
  return hDisplay + mDisplay + sDisplay
}

export const getPercentage = (value: number, totalValue: number) => {
  return !value || value < 0 ? 0 : (value * 100) / (totalValue || 1)
}
// to randomize array
export const shuffleArray = (array) => {
  let arrayLength = array?.length,
    arrayElm,
    arrayIndex

  while (arrayLength) {
    arrayIndex = Math.floor(Math.random() * arrayLength--)
    arrayElm = array[arrayLength]
    array[arrayLength] = array[arrayIndex]
    array[arrayIndex] = arrayElm
  }

  return array
}

export const ExaminationType = [
  { value: 'REC', label: 'Recruitment' },
  { value: 'UPS', label: 'Upskilling' },
  { value: 'CER', label: 'Certification' },
]

export const VisibilityOptions = [
  { value: 'A', label: 'Agency' },
  { value: 'C', label: 'Candidate' },
  { value: 'AL', label: 'Both (Candidate & Agency)' },
]

export const DeactivationReminderOptions = [
  { value: '1', label: '1 Days Before' },
  { value: '2', label: '2 Days Before' },
  { value: '3', label: '3 Days Before' },
  { value: '5', label: '5 Days Before' },
  { value: '7', label: '1 Week Before' },
  { value: '14', label: '2 Weeks Before' },
  { value: '0', label: 'On the Day of Deactivation' },
]

export const locationTypes = [
  { label: 'On-Site', icon: WhiteCheckIcon, value: 'O' },
  { label: 'Remote', icon: GrayCheckCheckIcon, value: 'R' },
  { label: 'Hybrid', icon: GrayCheckCheckIcon, value: 'H' },
]

export const jobType = [
  { label: 'Full Time', icon: WhiteCheckIcon, value: 'FT' },
  { label: 'Part Time', icon: GrayCheckCheckIcon, value: 'PT' },
  { label: 'Temporary', icon: GrayCheckCheckIcon, value: 'TM' },
  { label: 'Internship', icon: GrayCheckCheckIcon, value: 'IN' },
]

export const ScheduleType = [
  { label: 'Day Shift', icon: WhiteCheckIcon, value: 'DS' },
  { label: 'Night Shift', icon: GrayCheckCheckIcon, value: 'NS' },
  { label: 'Morning Shift', icon: GrayCheckCheckIcon, value: 'MS' },
  { label: 'Rotation', icon: GrayCheckCheckIcon, value: 'RT' },
  { label: 'Weekday', icon: GrayCheckCheckIcon, value: 'WD' },
  { label: 'Weekends', icon: GrayCheckCheckIcon, value: 'WE' },
  { label: 'Others', icon: GrayCheckCheckIcon, value: 'OT' },
]

export const VisibilityStatus = (visibility: string) => {
  switch (visibility) {
    case 'A':
      return 'Agency'
    case 'C':
      return 'Candidate'
    case 'AL':
      return 'Both (Candidate & Agency)'
    default:
      return ''
  }
}

export const getExamStatus = (status: string) => {
  switch (status) {
    case 'ACTIVE':
      return 'Completed'
    case 'READY':
      return 'Ready'
    case 'ASSIGNED':
      return 'Assigned'
    case 'EVALUATING_RESULT':
      return 'Evaluating Result'
    case 'RESULT_GENERATED':
      return 'Result Generated'
    default:
      return ''
  }
}

export const getExaminationType = (type: string) => {
  switch (type) {
    case 'REC':
      return 'Recruitment'
    case 'UPS':
      return 'Upskilling'
    case 'CER':
      return 'Certification'
    default:
      return ''
  }
}

export const dangerouslySetHTML = (html, style?: any) => {
  let updatedValue = html?.toString()
  if (html?.includes('<?php')) {
    updatedValue = html
      ?.replaceAll('<?php', '&lt;?php')
      ?.replaceAll('?>', '?&gt;')
      ?.replaceAll('\\n', '\n ')
  }
  return (
    <pre
      style={
        style
          ? style || {}
          : {
              fontFamily: `'Lato', sans-serif`,
              marginTop: '0.1rem',
              marginBottom: 0,
              wordBreak: 'break-all',
            }
      }
    >
      <span
        dangerouslySetInnerHTML={{
          __html: updatedValue || '-',
        }}
      />
    </pre>
  )
}

export const getProgressBarBgColor = (percentage: number) => {
  if (percentage >= 1 && percentage <= 40) {
    return 'poor'
  } else if (percentage >= 41 && percentage <= 69) {
    return 'average'
  } else if (percentage >= 70) {
    return 'good'
  }
}

export const RESULT_BUFFER_TIME = 5
export const RESULT_VALIDATION_BUFFER = 4
export const questionOptionsAlphabets = ['A', 'B', 'C', 'D', 'E', 'F']
export const createManually = 'createManually'
export const assignToSME = 'assignToSME'

export const QuestionVisibility = [
  { value: 'PUBLIC', label: 'Public' },
  { value: 'PRIVATE', label: 'Private' },
  { value: 'All', label: 'All' },
]

export const formatBytes = (bytes, decimals = 2) => {
  if (!+bytes) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

  const i = Math.floor(Math.log(bytes) / Math.log(k))

  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}
export const deviceCameraCheck = (fun) => {
  if ('mediaDevices' in navigator && 'getUserMedia' in navigator.mediaDevices) {
    // Access the media devices and request camera access
    navigator.mediaDevices
      .enumerateDevices()
      .then((devices) => {
        // Check if any device is a video input device (camera)
        const hasCamera = devices.some((device) => {
          return device.kind === 'videoinput'
        })

        if (hasCamera) {
          fun()

          console.log('Device has a camera.')
        } else {
          console.log('Device does not have a camera.')
        }
      })
      .catch(function (err) {
        console.error('Error enumerating devices: ', err)
      })
  } else {
    console.log('Camera access not supported in this browser.')
  }
}

export const getDifficultyLevel = (easy = 0, medium = 0, hard = 0) => {
  const max = _.max([easy, medium, hard])
  if (max === easy) {
    return 'Entry Level'
  } else if (max === medium) {
    return 'Intermediate Level'
  } else {
    return 'Advanced Level'
  }
}

// constants for job role creation
export const addCandidate = 'add-candidate'
export const inviteCandidate = 'invite-candidate'
export const uploadResumes = 'upload-resumes'
export const uploadCandidates = 'upload-candidates'

export const UPLOAD_RESUME = 'UR'

export const getExamCreationMode = (mode: string) => {
  switch (mode) {
    case 'AG':
      return 'Auto Generate'
    case 'HP':
      return 'Hand Picked'
    case 'SFL':
      return 'Selected From Library'
    case 'ATS':
      return 'Assigned to SME'
    default:
      return 'NA'
  }
}

export const monthsToYearsAndMonths = (months) => {
  const years = Math.floor(months / 12)
  const remainingMonths = months % 12

  if (years === 0) {
    return `0.${remainingMonths}`
  } else if (remainingMonths === 0) {
    return `${years}`
  } else {
    return `${years}.${remainingMonths}`
  }
}

export const formatExperienceYearsAndMonths = (years) => {
  const totalMonths = Math.round(years * 12)
  const wholeYears = Math.floor(totalMonths / 12)
  const remainingMonths = totalMonths % 12

  let result = ''

  if (wholeYears > 0) {
    result += `${wholeYears} Yr${wholeYears > 1 ? 's' : ''}`
  }

  if (remainingMonths > 0) {
    if (wholeYears > 0) {
      result += ' & '
    }
    result += `${remainingMonths} Month${remainingMonths > 1 ? 's' : ''}`
  }

  if (result === '') {
    result = '0 Months'
  }

  return result
}

export const formatExperienceToYearsAndMonths = (months) => {
  const years = Math.floor(months / 12)
  const remainingMonths = months % 12

  const yearString = years > 0 ? `${years} year${years > 1 ? 's' : ''}` : ''
  const monthString =
    remainingMonths > 0
      ? `${remainingMonths} month${remainingMonths > 1 ? 's' : ''}`
      : ''

  return [yearString, monthString].filter(Boolean).join(' and ')
}

export const formatTotalCandidateNumber = (num) => {
  if (num < 1000) {
    return num.toString()
  }
  const roundedValue = Math.ceil(num / 1000)
  return roundedValue + 'k+'
}

export const dateFormat = (date) => {
  return moment(date).format('DD MMM, YYYY')
}

export const checkForNewBadge = (date) => {
  const currentYear = new Date().getFullYear()
  const currentDay = new Date().getDate()
  const currentMonth = new Date().getMonth()

  const createdYear = new Date(date).getFullYear()
  const createdDay = new Date(date).getDate()
  const createdMonth = new Date(date).getMonth()

  if (
    currentYear === createdYear &&
    currentDay === createdDay &&
    currentMonth === createdMonth
  ) {
    return true
  } else {
    return false
  }
}

export const ASCENDING = 'asc'
export const DESCENDING = 'desc'
export const Pending = 'PEN'
export const Accepted = 'ACC'
export const Rejected = 'REJ'

export function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export const QUESTION_PAPER_NAME_REGEX = /[*?:\\/\[\]]/g
